import { gql } from "@apollo/client";

export interface IGetPublicAppreciationDistributeInput {
  limit?: number;
  offset?: number;
}

const GET_APPRECIATIONS_ENABLE_FOR_PRESELECTION = gql`
  query appreciationsEnableForPreselection {
    appreciationsEnableForPreselection {
      id
      name
      questions
      description

      dimensions {
        id
        name
      }

      creator {
        id
        name
        lastname
        email
        profileImage
      }

      roles {
        id
        name
      }
    }
  }
`;

const GET_PUBLIC_APPRECIATIONS = gql`
  query publicAppreciations(
    $getPublicAppreciationDistributeInput: GetPublicAppreciationDistributeInput!
  ) {
    publicAppreciations(
      getPublicAppreciationDistributeInput: $getPublicAppreciationDistributeInput
    ) {
      id
      token
      createdAt
      userName
      completedPercent
      userGeneralMaturityLevel
      seniorityByUserGeneralMaturityLevel
      completed
      started
      role
      appreciation {
        name
      }
      userEmail
      startedAt
      timeToAnswer
    }
  }
`;

export interface IGetUserPublicAppreciationInput {
  token: string;
}

const GET_USER_PUBLIC_APPRECIATION = gql`
  query userPublicAppreciation(
    $getUserPublicAppreciationInput: GetUserPublicAppreciationInput!
  ) {
    userPublicAppreciation(
      getUserPublicAppreciationInput: $getUserPublicAppreciationInput
    ) {
      completedPercent
      createdAt
      userEmail
      id
      activeQuestionIndex
      completed
      isAvailable
      startDate
      startedAt
      endDate
      maxQuestions
      distributedBy {
        name
        lastname
        email
        profileImage
        rolePublic {
          name
        }
      }
      timeToAnswer
      appreciation {
        id
        name
        timeToAnswer
        description
        dimensions {
          id
          name
        }
        thumbnail
      }
      started
      completed
      userGeneralMaturityLevel
      userMaturityLevelByDimension {
        dimensionName
        maturityname
        percent
      }
      questions {
        id
        answered
        answeredAt
        originalId
        name
        dimension
        isCorrect
        correctOptions
        options {
          originalId
          name
          checked
        }
      }
      role
    }
  }
`;

const GET_USER_PUBLIC_APPRECIATION_PAGINATED = gql`
  query PublicAppreciationsPaginated(
    $getPublicAppreciationFilteredDistributeInput: GetPublicAppreciationFilteredDistributeInput!
  ) {
    publicAppreciationsPaginated(
      GetPublicAppreciationFilteredDistributeInput: $getPublicAppreciationFilteredDistributeInput
    ) {
      publicAppreciations {
        id
        token
        createdAt
        userName
        completedPercent
        userGeneralMaturityLevel
        seniorityByUserGeneralMaturityLevel
        completed
        started
        role
        appreciation {
          name
        }
        userEmail
        startedAt
        timeToAnswer
      }
      total
      totalCompleted
      totalPendings
    }
  }
`;

export default {
  GET_PUBLIC_APPRECIATIONS,
  GET_APPRECIATIONS_ENABLE_FOR_PRESELECTION,
  GET_USER_PUBLIC_APPRECIATION,
  GET_USER_PUBLIC_APPRECIATION_PAGINATED
};
